import React from "react";

function ModalSuccessLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
    >
      <circle cx="32" cy="32.5" r="32" fill="white" />
      <path
        d="M48.5 23.5L32.8241 38.751C30.5176 40.9949 29.3644 42.1169 27.9428 42.1169C26.5211 42.1169 25.3679 40.9949 23.0615 38.751L16 31.881"
        stroke="#7950FF"
        strokeWidth="7"
      />
    </svg>
  );
}

export default ModalSuccessLogo;
